/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_a4_97_52 as Componente_a4_97_52,
  rec_J2 as J2,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sr as Sr,
  rec_W2 as W2,
  rec_q2 as q2,
  rec_t4 as t4,
} from "../../runtime/index.jsx";
export function FiltrosOrganigrama(e) {
  let t = (0, ReactCompiler.c)(47),
    { fila: n, onAbrir: r, resaltada: i, mostrarFoto: a, className: o } = e,
    s = i !== void 0 && i,
    c = a === void 0 || a,
    l = o === void 0 ? `` : o,
    u = !!n.vacante,
    d = n.alertas?.length ?? 0,
    f = t4[n.referencia],
    p = n.referencia !== `sinPuesto` && n.referencia !== `unidad`,
    m;
  t[0] === n ? (m = t[1]) : ((m = W2(n)), (t[0] = n), (t[1] = m));
  let h = m,
    _;
  t[2] !== p || t[3] !== n || t[4] !== r
    ? ((_ = () => {
        p && r?.(n);
      }),
      (t[2] = p),
      (t[3] = n),
      (t[4] = r),
      (t[5] = _))
    : (_ = t[5]);
  let v = !p || void 0,
    y = h?.clave,
    b;
  t[6] === n ? (b = t[7]) : ((b = q2(n)), (t[6] = n), (t[7] = b));
  let x;
  t[8] === n ? (x = t[9]) : ((x = J2(n)), (t[8] = n), (t[9] = x));
  let S = h?.nombre,
    C;
  t[10] !== f || t[11] !== S || t[12] !== b || t[13] !== x
    ? ((C = [b, x, S, f].filter(Boolean)),
      (t[10] = f),
      (t[11] = S),
      (t[12] = b),
      (t[13] = x),
      (t[14] = C))
    : (C = t[14]);
  let w = C.join(` — `),
    T = `relative flex h-full w-full items-center gap-3 rounded-2xl border px-3 py-2 text-left shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) ${p ? `hover:border-(--accent-border) hover:shadow-md` : `cursor-default`} ${f ? `bg-(--panel)` : `bg-(--bg)`} ${s ? `border-(--accent) ring-2 ring-(--accent-border)` : u || f ? `border-dashed border-(--text)/40` : `border-(--border)`} ${l}`,
    E;
  t[15] !== f || t[16] !== h
    ? ((E =
        h && !f
          ? {
              backgroundImage: `linear-gradient(90deg, ${h.fondo}, transparent 60%)`,
            }
          : void 0),
      (t[15] = f),
      (t[16] = h),
      (t[17] = E))
    : (E = t[17]);
  let D;
  t[18] === h
    ? (D = t[19])
    : ((D = h && (
        <span
          aria-hidden={`true`}
          className={`absolute inset-y-2 left-0 w-1.5 rounded-r-full`}
          style={{
            background: h.color,
          }}
        />
      )),
      (t[18] = h),
      (t[19] = D));
  let O;
  t[20] !== n || t[21] !== c
    ? ((O =
        n.referencia === `unidad` ? (
          <span
            aria-hidden={`true`}
            className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-dashed border-(--text)/40 text-(--text)`}
            children={<Sr className={`h-5 w-5`} />}
          />
        ) : (
          <Componente_a4_97_52 fila={n} activa={c} />
        )),
      (t[20] = n),
      (t[21] = c),
      (t[22] = O))
    : (O = t[22]);
  let k = `line-clamp-2 text-sm leading-tight font-semibold ${u ? `text-(--text)` : `text-(--text-h)`}`,
    A;
  t[23] === n ? (A = t[24]) : ((A = q2(n)), (t[23] = n), (t[24] = A));
  let j;
  t[25] !== k || t[26] !== A
    ? ((j = <span className={k} children={A} />),
      (t[25] = k),
      (t[26] = A),
      (t[27] = j))
    : (j = t[27]);
  let M;
  t[28] !== n || t[29] !== f
    ? ((M =
        n.referencia === `unidad` ? (
          <span className={`text-xs leading-snug text-(--text)`} children={f} />
        ) : (
          <JSXRuntime.Fragment
            children={[
              <span
                className={`${f ? `line-clamp-1` : `line-clamp-2`} text-xs leading-snug text-(--text)`}
                children={J2(n) || `Sin cargo correcto`}
              />,
              f && (
                <span
                  className={`truncate text-[11px] font-medium text-(--warning)`}
                  children={f}
                />
              ),
            ]}
          />
        )),
      (t[28] = n),
      (t[29] = f),
      (t[30] = M))
    : (M = t[30]);
  let N;
  t[31] !== j || t[32] !== M
    ? ((N = (
        <span
          className={`flex min-w-0 flex-1 flex-col gap-0.5`}
          children={[j, M]}
        />
      )),
      (t[31] = j),
      (t[32] = M),
      (t[33] = N))
    : (N = t[33]);
  let P;
  t[34] === d
    ? (P = t[35])
    : ((P = d > 0 && (
        <span
          className={`absolute top-1.5 right-1.5 h-2.5 w-2.5 rounded-full bg-(--warning)`}
          aria-label={
            d === 1 ? `Tiene algo por revisar` : `Tiene ${d} cosas por revisar`
          }
        />
      )),
      (t[34] = d),
      (t[35] = P));
  let F;
  return (
    t[36] !== w ||
    t[37] !== T ||
    t[38] !== E ||
    t[39] !== D ||
    t[40] !== O ||
    t[41] !== N ||
    t[42] !== P ||
    t[43] !== _ ||
    t[44] !== v ||
    t[45] !== y
      ? ((F = (
          <button
            type={`button`}
            onClick={_}
            aria-disabled={v}
            data-cultivo={y}
            title={w}
            className={T}
            style={E}
            children={[D, O, N, P]}
          />
        )),
        (t[36] = w),
        (t[37] = T),
        (t[38] = E),
        (t[39] = D),
        (t[40] = O),
        (t[41] = N),
        (t[42] = P),
        (t[43] = _),
        (t[44] = v),
        (t[45] = y),
        (t[46] = F))
      : (F = t[46]),
    F
  );
}
